import { Datagrid, DateField, ListProps, TextField } from 'react-admin';
import { CustomList } from '../../components';
import ActiveField from '../../components/ActiveField';

export default function PostsList(props: ListProps) {
  return (
    <CustomList {...props} sort={{ field: 'date', order: 'DESC' }}>
      <Datagrid rowClick="edit">
        
        <DateField 
          locales="pt-BR" 
          options={{ timeZone: 'UTC' }} 
          label="Data" 
          source="date" 
        />
        <TextField label="Título" source="title" />

        <ActiveField label="Ativo" />
      </Datagrid>
    </CustomList>
  );
}
